<template>
    <b-container>
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Tickets de Soporte - Abiertos</h4>
        <b-row class="justify-content-center">
            <b-col cols="12" class="mt-4 mb-2">
                <b-form-group class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="search" v-model="search" type="search" placeholder="Buscar" class="pad-3-15 btlr-30 bblr-30"></b-form-input>

                        <b-input-group-append>
                            <b-button variant="default" :disabled="!search" @click="search = ''" class="m-0 btlr-0 bblr-0">
                                <i class="material-icons mdi mdi-close"></i>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="justify-content-center">
            <b-col cols="12" class="px-0">
                <b-table
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                    class="my-2 border-bottom"
                    stacked="sm"
                    hover
                    small
                    show-empty
                    no-border-collapse
                    table-variant="light"
                    details-td-class="px-0"
                    empty-filtered-text="No hay tickets que coincidan con la búsqueda"
                    empty-text="No hay tickets abiertos"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="search"
                    :busy="isBusy"
                    @filtered="onFiltered">
                    <template #cell(actions)="row">
                        <b-button variant="primary" size="sm" title="Ver Detalles" :to="row.item.id+'/details'">
                            <i class="material-icons">visibility</i>
                        </b-button>
                        <b-button variant="danger" size="sm" title="Cerrar Ticket" @click="close(row.item.id)" :disabled="row.item.status === 303">
                            <i class="material-icons">cancel</i>
                        </b-button>
                    </template>

                    <template #table-busy>
                        <div class="text-center text-danger my-4">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Actualizando...</strong>
                        </div>
                    </template>
                </b-table>
            </b-col>
            <b-col sm="5" md="6">
                <b-form-group
                    label="Mostrar:"
                    label-for="per-page-select"
                    label-cols-sm="4"
                    label-cols-md="6"
                    label-cols-lg="9"
                    label-align-sm="right"
                    label-size="sm"
                    class="mt-2 mb-8">
                    <b-form-select
                        id="per-page-select"
                        v-model="perPage"
                        :options="pageOptions"
                        size="sm"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="7" md="6">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="fill"
                    size="sm"
                    class="mt-2 mb-8"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

import axios from "axios";

const ROLE_LABELS = {
    Customer: 'Cliente',
    Partner: 'Agente',
    Supervisor: 'Supervisor',
    Cashier: 'Cajero',
    Administrator: 'Admin',
    Guest: 'Invitado'
};

export default {
    name: "Open",
    props: [ 'user' ],
    data: () => ({
        id: 0,
        isBusy: true,
        search: '',
        fields: [
            { key: 'id', label: 'Ticket #', sortable: true },
            { key: 'user_name', label: 'Usuario', sortable: true },
            { key: 'user_role', label: 'Rol', sortable: true, formatter: (v) => ROLE_LABELS[v] || v },
            { key: 'reason', label: 'Motivo', sortable: true },
            { key: 'status_name', label: 'Estado', sortable: true },
            { key: 'last_admin_reply', label: 'Atendido Por', sortable: true, formatter: (v) => v || 'Sin responder' },
            { key: 'actions', label: 'Acción', sortable: false }
        ],
        items: [],
        totalRows: 1,
        currentPage: 1,
        perPage: 25,
        pageOptions: [25, 50, 100, { value: -1, text: "Todos" }]
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'supportpage');
        this.getData();
    },
    methods: {
        getData() {
            axios.get('/api/admin/tickets/open').then((res) => {
                if (res.data.status === 'success') {
                    this.items = res.data.tickets;
                    this.totalRows = this.items.length;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.isBusy = false;
            });
        },
        clearData(id) {
            if (id) {
                this.id = id;
                const items = this.items;

                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === id) {
                        this.form = items[i];
                    }
                }
            } else {
                this.id = 0;
            }
        },
        close(id) {
            this.$swal({
                title: '¿Estas seguro de cerrar este ticket?',
                text: 'Ticket #' + id,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Si, cerrar',
                confirmButtonColor: '#28a745',
                cancelButtonText: 'No, dejar abierto',
                cancelButtonColor: '#dc3545',
                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true
            }).then((result) => {
                if (result.value) {
                    this.id = id;

                    let formData = new FormData();
                    formData.append('id', id);

                    axios.post('/api/customer/tickets/close', formData).then(res => {
                        if (res.data.status === 'success') {
                            this.getData();
                            this.clearData();
                        }
                        this.$root.$bvToast.toast(res.data.msg, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: res.data.status,
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    }).catch(err => {
                        this.$root.$bvToast.toast(err.response.data.errors, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: 'error',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    });
                }
            });
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        }
    }
}
</script>

<style scoped>

</style>
